import React from "react";

const FeatuersBanner = () => {
  return (
    <section
      className="relative w-full py-6 bg-home-background  h-[448px] rounded-[20px] mt-12"
      id="company-section"
    >
      <div className="w-full mt-8">
        <div className="space-y-5 px-5">
          <div className="font-normal  text-black font-IBM text-[48px] text-center w-full">
            <span className="italic">Features</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatuersBanner;
